const getBlacklist = state => {
  return state.blacklist.blacklist;
};
const getBlacklistErrors = state => {
  return state.blacklist.error;
};

const blacklistSelectors = { getBlacklist, getBlacklistErrors };

export default blacklistSelectors;
